<template>
  <div>
    <el-container class="main-layout">
      <!-- 侧边栏 -->
      <el-aside width="240px">
        <div class="logo-container">
          <!-- <img src="@/assets/logo.svg" alt="WMS Logo" class="logo"> -->
           <span class="system-title">综合业务系统</span>
        </div>
        <el-menu 
          :default-active="$route.path" 
          class="el-menu-vertical" 
          background-color="#304156" 
          text-color="#fff"
          active-text-color="#409EFF" 
          :router="true">
          
          <!-- 遍历路由生成菜单 -->
          <template v-for="route in filteredRoutes">
            <!-- 只显示非隐藏且有标题的路由 -->
            <template v-if="route.meta && route.meta.title && !route.hidden">
              <el-submenu v-if="route.children && route.children.length" :key="route.path" :index="route.path">
                <template slot="title">
                  <i v-if="route.meta.icon" :class="route.meta.icon"></i>
                  <span>{{ route.meta.title }}</span>
                </template>
                <el-menu-item 
                  v-for="child in filterChildRoutes(route.children)" 
                  :key="child.path" 
                  :index="child.path">
                  <i v-if="child.meta && child.meta.icon" :class="child.meta.icon"></i>
                  <span>{{ child.meta.title }}</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-else :key="route.path + '-item'" :index="route.path">
                <i v-if="route.meta.icon" :class="route.meta.icon"></i>
                <span>{{ route.meta.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-aside>

      <!-- 主要内容区 -->
      <el-container>
        <el-header height="60px">
          <div class="header-left">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item v-if="$route.meta.title">{{ $route.meta.title }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="header-right">
            <div class="header-icons">
              <el-badge :value="3" class="notice-badge">
                <i class="el-icon-bell"></i>
              </el-badge>
              <i class="el-icon-full-screen" @click="toggleFullScreen"></i>
            </div>
            <el-divider direction="vertical"></el-divider>
            <el-dropdown>
              <div class="user-info">
                <div class="avatar">
                  <svg class="avatar-svg" viewBox="0 0 40 40">
                    <circle cx="20" cy="20" r="18" fill="#e1e8f0" stroke="#a0cfff" stroke-width="2" />
                    <circle cx="20" cy="16" r="6" fill="#409EFF" />
                    <path d="M8 36c0-8 6-12 12-12s12 4 12 12" fill="#409EFF" />
                  </svg>
                </div>
                <span class="username">{{ displayName }}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="handleCommand('password')">
                  <i class="el-icon-key"></i>修改密码
                </el-dropdown-item>
                <!-- <el-dropdown-item>
                  <i class="el-icon-user"></i>个人信息
                </el-dropdown-item> -->
                <el-dropdown-item @click.native="handleCommand('logout')">
                  <i class="el-icon-switch-button"></i>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>

        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>

    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="100px"
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input
            v-model="passwordForm.oldPassword"
            type="password"
            placeholder="请输入原密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelPassword">取 消</el-button>
        <el-button type="primary" @click="submitPassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'MainLayout',
  data() {
    // 验证密码是否一致
    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      passwordDialogVisible: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      // 修改密码表单校验规则
      passwordRules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('user', [
      'token',
      'userInfo'
    ]),
    ...mapState('user', ['userInfo', 'permissions']),
    displayName() {
      // 提供一个后备的显示名称
      return this.userInfo?.name || 
             this.userInfo?.UserName || 
             this.userInfo?.userName || 
             this.userInfo?.realName || 
             '未知用户'
    },
    // 过滤后的路由
    filteredRoutes() {
      // 打印后端返回的权限
      console.log('========== 后端权限列表 ==========')
      console.log("--->",this.permissions)
      this.permissions.forEach(permission => {
        console.log({
          name: permission.MenuName,
          path: permission.Path,
          parentId: permission.ParentID,
          icon: permission.Icon
        })
      })

      // 打印前端路由配置
      console.log('========== 前端路由配置 ==========')
      const mainRoute = this.$router.options.routes.find(r => r.path === '/')
      if (mainRoute && mainRoute.children) {
        mainRoute.children.forEach(route => {
          console.log({
            name: route.name,
            path: route.path,
            meta: route.meta,
            children: route.children?.map(child => ({
              name: child.name,
              path: child.path,
              meta: child.meta
            }))
          })
        })
      }

      // 原有的过滤逻辑
      if (!mainRoute || !mainRoute.children) return []

      const homeRoute = mainRoute.children.find(route => route.path === '/home')
      const routes = homeRoute ? [homeRoute] : []

      mainRoute.children.forEach(route => {
        if (route.path === '/home' || route.hidden) return

        console.log('正在匹配路由:', {
          routePath: route.path,
          routeName: route.name,
          matchingPermissions: this.permissions
            .filter(p => p.Path.toLowerCase() === route.path.toLowerCase())
            .map(p => p.MenuName)
        })

        const hasPermission = this.hasPermission(route.path)
    
       
        if (hasPermission) {
          const newRoute = { ...route }
          
          if (route.children?.length) {
            newRoute.children = route.children.filter(child => {
              console.log('正在匹配子路由:', {
                childPath: child.path,
                childName: child.name,
                matchingPermissions: this.permissions
                  .filter(p => p.Path.toLowerCase() === child.path.toLowerCase())
                  .map(p => p.MenuName)
              })
              return this.hasPermission(child.path)
            })
          }

          routes.push(newRoute)
        }
      })

      console.log('========== 最终过滤结果 ==========')
      console.log('过滤后的菜单:', routes.map(route => ({
        name: route.name,
        path: route.path,
        children: route.children?.map(child => ({
          name: child.name,
          path: child.path
        }))
      })))

      return routes
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 'password') {
        this.showPasswordDialog()
      } else if (command === 'logout') {
        this.handleLogout()
      }
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 使用 vuex action 来登出
        this.$store.dispatch('user/logout')
        // 跳转到登录页
        this.$router.push('/login')
        this.$message.success('退出成功')
      }).catch(() => {
        // 取消退出时不做任何操作
      })
    },
    toggleFullScreen() {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    },
    // 显示修改密码对话框
    showPasswordDialog() {
      console.log('显示密码对话框')
      this.passwordDialogVisible = true
    },

    // 取消修改密码
    cancelPassword() {
      this.passwordDialogVisible = false
      this.resetPasswordForm()
    },

    // 重置修改密码表单
    resetPasswordForm() {
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.$refs.passwordForm && this.$refs.passwordForm.resetFields()
    },

    // 提交修改密码
    submitPassword() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          request({
            url: '/api/v1/user/change-password',
            method: 'POST',
            data: {
              oldPassword: this.passwordForm.oldPassword,
              newPassword: this.passwordForm.newPassword,
              confirmPassword: this.passwordForm.confirmPassword
            }
          }).then(response => {
            if (response.status === 1) {
              this.$message.success('密码修改成功，请重新登录')
              this.passwordDialogVisible = false
              this.resetPasswordForm()
              // 退出登录
              this.handleLogout()
            } else {
              this.$message.error(response.msg || '密码修改失败')
            }
          }).catch(error => {
            this.$message.error('密码修改失败：' + (error.msg || '请检查原密码是否正确'))
          })
        }
      })
    },
    // 检查是否有权限访问路由
    hasPermission(path) {
      // 原有的权限检查逻辑
      console.log('\n========== 权限匹配过程 ==========')
      console.log('正在检查路径:', path)
      
      // 1. 先检查是否是根路由
      const isRootRoute = this.permissions.some(permission => {
        return permission.ParentID === '0' && permission.Path.toLowerCase() === path.toLowerCase()
      })

      if (isRootRoute) {
        console.log('找到根路由权限 ✅')
        return true
      }

      // 2. 检查是否是子路由
      const hasPermission = this.permissions.some(permission => {
        const cleanPath = path.split('/:')[0].toLowerCase()
        const cleanPermissionPath = permission.Path.split('/:')[0].toLowerCase()


      
        
        console.log(`比较路径:`, {
          路由路径: cleanPath,
          权限路径: cleanPermissionPath,
          菜单名称: permission.MenuName,
          父级ID: permission.ParentID,
          菜单类型: permission.MenuType,
          状态: permission.Status,
          可见性: permission.Visible
        })

        // 路径匹配，且菜单状态和可见性都正常
        const matched = cleanPath === cleanPermissionPath 
          && permission.Status === 1 
          && permission.Visible === 1

        if (matched) {
          console.log(`✅ 匹配成功: ${permission.MenuName}`)
        }
        
        return matched
      })

      console.log('最终匹配结果:', hasPermission ? '✅ 有权限' : '❌ 无权限')
      console.log('================================\n')
      
      return hasPermission
    },

    // 过滤子路由
    filterChildRoutes(children) {
      if (!children) return []
      return children.filter(child => {
        if (child.hidden) {
          console.log('跳过隐藏路由:', child.path)
          return false
        }
        return this.hasPermission(child.path)
      })
    },

    // 获取权限
    async fetchPermissions() {
      if (this.userInfo?.roleId) {
        await this.$store.dispatch('user/getPermissions')
      }
    }
  },
  created() {
    // 组件创建时获取权限
    this.fetchPermissions()
  }
}
</script>
<style scoped>
.main-layout {
  min-height: 100vh;
}

.logo-container {
  height: 60px;
  padding: 5px;
  background: #304156;
  text-align: center;
}

.logo {
  height: 40px;
}

.el-aside {
  background-color: #304156;
}

.el-header {
  background: linear-gradient(90deg, #ffffff 0%, #f6f9fc 100%);
  border-bottom: 1px solid rgba(230, 230, 230, 0.5);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.header-left {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-icons {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 20px;
  color: #606266;
}

.header-icons i {
  cursor: pointer;
  transition: color 0.3s;
}

.header-icons i:hover {
  color: #409EFF;
}

.notice-badge {
  margin-right: 4px;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.user-info:hover {
  background-color: rgba(64, 158, 255, 0.1);
}

.avatar {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}

.avatar-svg {
  width: 100%;
  height: 100%;
}

.username {
  font-size: 14px;
  color: #303133;
  margin-right: 4px;
}

.el-icon-caret-bottom {
  font-size: 12px;
  color: #909399;
}

.el-dropdown-menu i {
  margin-right: 8px;
}

/* 面包屑样式优化 */
.el-breadcrumb {
  font-size: 14px;
}

.el-breadcrumb__inner a {
  color: #606266;
  font-weight: normal;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #303133;
  font-weight: 500;
}

.el-menu-vertical {
  border-right: none;
}

.el-menu-item [class^="el-icon-"] {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}

.el-submenu [class^="el-icon-"] {
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
}

.el-menu-item,
.el-submenu__title {
  height: 50px;
  line-height: 50px;
}

/* 添加修改密码对话框样式 */
.el-dialog {
  .el-input {
    width: 100%;
  }
  
  .dialog-footer {
    text-align: right;
  }
}

.el-dropdown-menu__item {
  display: flex;
  align-items: center;
  
  i {
    margin-right: 8px;
  }
}

.el-main {
  padding: 20px;
  overflow-y: visible;
}

body {
  margin: 0;
}

.system-title {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
}
</style>
